import React from 'react';
import { useParams, useLocation, useHistory } from 'react-router-dom';
import cn from 'classnames';
import HorizontalChart from '../../components/HorizontalChart/HorizontalChart';
import PieChart from '../../components/PieChart/PieChart';
import { statisticsPages } from '../../../../constants/statisticsPages';
import {
  pieCharts,
  horizontalCharts,
  chartNames,
  lifetimePieCharts,
  lifetineHorizontalCharts,
} from './constants';
import useHiddenMarksItem from '../../hooks/useHiddenMarksItem';
import { filterNames } from '../../constants/filterNames';
import { upperCaseFirst } from '../../../../helpers/upperCaseFirst';
import styles from './InnerPage.module.scss';
import { Report } from '../../components/Report/Report';

const InnerPage = ({ chartTitle, onlyThisPeriod = false }) => {
  let { page } = useParams();
  const { search } = useLocation();
  const { replace } = useHistory();

  const handlers = {
    [chartNames.address]: (item) => {
      const searchParams = new URLSearchParams(search);
      const houseId = String(item.id);
      const houseFilterName = filterNames.houses;
      const streetFilterName = filterNames.streets;

      const current = searchParams.has(houseFilterName)
        ? new Set(searchParams.get(houseFilterName).split(','))
        : null;

      if (current?.has(houseId)) {
        current.delete(houseId);
        const value = Array.from(current).join(',');
        searchParams.set(houseFilterName, value);
      } else {
        searchParams.set(houseFilterName, houseId);
        searchParams.set(streetFilterName, item.streetId);
      }

      replace({ search: searchParams.toString() });
    },
  };

  const hiddenMarksItem = useHiddenMarksItem();

  return (
    <>
      {page === 'report' ? (
        <Report onlyThisPeriod={onlyThisPeriod} />
      ) : (
        <div
          className={cn(styles.block, styles.charts, {
            [styles.lifetime]: page === statisticsPages.lifetime,
          })}
        >
          {page !== statisticsPages.lifetime && (
            <>
              {pieCharts.map((chart) => (
                <PieChart
                  key={chart.area}
                  style={{ gridArea: chart.area }}
                  title={
                    page === statisticsPages.all
                      ? upperCaseFirst(chart.title)
                      : `${chartTitle} ${chart.title}`
                  }
                  filter={chart.filter}
                  marksChart={chart.marksChart}
                  hiddenItem={chart.marksChart && hiddenMarksItem}
                />
              ))}
              {horizontalCharts.map((chart) => (
                <HorizontalChart
                  key={chart.area}
                  style={{ gridArea: chart.area }}
                  title={
                    page === statisticsPages.all
                      ? upperCaseFirst(chart.title)
                      : `${chartTitle} ${chart.title}`
                  }
                  showNoIndicated
                  filter={chart.filter}
                  placeholderType={chart.placeholderType}
                  onItemClick={handlers[chart.area]}
                />
              ))}
            </>
          )}
          {page === statisticsPages.lifetime && (
            <>
              {lifetimePieCharts.map((chart) => (
                <PieChart
                  key={chart.area}
                  style={{ gridArea: chart.area }}
                  title={chart.title}
                  filter={chart.filter}
                  renderContent={chart.renderContent}
                  valueKey={chart.valueKey}
                />
              ))}
              {lifetineHorizontalCharts.map((chart) => (
                <HorizontalChart
                  key={chart.area}
                  style={{ gridArea: chart.area }}
                  title={chart.title}
                  filter={chart.filter}
                  valueKey={chart.valueKey}
                  nullContent={chart.nullContent}
                />
              ))}
            </>
          )}
        </div>
      )}
    </>
  );
};

export default InnerPage;
